<template>
  <mothers-day_default-section class="menu--section-mothers_day_cocktails"
                               :menu="menu"
                               :section="section"
                               :menu-version="menuVersion"
                               :section-modifier="sectionModifier"
                               menu-item-component="mothers-day-cocktail-item">
  </mothers-day_default-section>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 0.1.0
 * @copyright  Copyright (C) 2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 *
 * 2026-07-20 (0.1.0) (jhoward)
 *   - Add App\Library\Js\Components\Menu\Section\MothersDay_cocktailsSection.vue for Mother's Day cocktails menu sections.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import MothersDay_defaultSection from "./MothersDay_defaultSection.vue";

export default defineComponent({
  components: {
    MothersDay_defaultSection
  },
  name: "MothersDay_cocktailsSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menuVersion: {
      type: String,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    }
  },
})
</script>

<style scoped>
.menu--section-mothers_day.menu--section-mothers_day_cocktails {
  padding-top: 47rem !important;
}

.menu--section-mothers_day_cocktails::before {
  background-image: url('/library/images/menu/background-mothers-day-cocktails-2026.jpg');
}

.menu--section-mothers_day_cocktails:deep(.menu--section_subtitle) {
  display: none;
}

@media (max-width: 700px) {
  .menu--section-mothers_day.menu--section-mothers_day_cocktails {
    padding-top: 85vw !important;
  }

  .menu--section-mothers_day.menu--section-mothers_day_cocktails::before {
    height: 85vw;
  }
}

.menu--section-mothers_day_cocktails:deep(.visual_menu--page_section-bottom .visual_menu--page_section-bottom::before),
.menu--section-mothers_day_cocktails:deep(.menu--page_content.menu--page_content-bottom.page-link-group-copy::before) {
  display: none;
}
</style>